
(function () {
  "use strict";

  function initialiseDGChecker() {
    const root = document.getElementById("dgs-checker");

    if (!root || root.dataset.ready === "1") return;
    root.dataset.ready = "1";

    /*
     * DG SOLUTIONS DANGEROUS GOODS CHECKER
     *
     * R = Dangerous Goods Review Required
     * S = Special Provision May Apply
     * N = Generally Not Dangerous Goods
     *
     * All results are preliminary screening guidance.
     * They are not confirmed transport classifications.
     */

    const raw = `
Lithium ion battery|Batteries|S|3480|9|li ion rechargeable battery power bank|Standalone rechargeable lithium ion batteries require battery specific assessment.|Air PI965 and applicable IATA provisions; sea SP188 may apply; road SP188 may apply.
Lithium ion battery in equipment|Batteries|S|3481|9|laptop battery installed equipment|Battery installed in or packed with equipment.|Air PI966 or PI967 as applicable; sea and road SP188 may apply.
Lithium metal battery|Batteries|S|3090|9|primary lithium battery non rechargeable|Standalone primary lithium batteries.|Air PI968; sea and road SP188 may apply.
Lithium metal battery in equipment|Batteries|S|3091|9|coin cell lithium device|Lithium metal batteries contained in or packed with equipment.|Air PI969 or PI970; SP188 may apply to sea and road.
Power bank|Batteries|S|3480|9|portable charger battery pack|Power banks are generally treated as batteries rather than equipment.|Check Wh rating, condition, PI965 and applicable modal provisions.
E-bike battery|Batteries|R|3480|9|electric bike battery 625wh 800wh 900wh|Large lithium ion battery requiring detailed review.|Capacity, testing, condition and carrier acceptance must be checked.
E-bike with battery installed|Vehicles|R|3171 / 3556|9|electric bicycle ebike pedelec|Classification depends on the vehicle and battery configuration.|Check current vehicle and battery entries and applicable modal provisions.
Electric scooter|Vehicles|R|3171 / 3556|9|e scooter electric kick scooter|Battery powered vehicle classification requires review.|Check battery type, installation, current UN entry and carrier acceptance.
Electric wheelchair|Vehicles|S|3171 / 3556|9|mobility scooter powered wheelchair|Battery powered mobility equipment may have specific transport arrangements.|Air passenger mobility aid rules differ from cargo shipment rules.
Electric vehicle|Vehicles|R|3556 / 3557 / 3558|9|ev car electric motorbike|Battery powered vehicle requiring modal classification.|Check chemistry, vehicle configuration and carrier conditions.
Hybrid vehicle|Vehicles|R|3166|9|hybrid car petrol electric|Fuel and battery systems may create multiple hazards.|Confirm propulsion system, fuel and current vehicle entries.
Lead acid wet battery|Batteries|R|2794 / 2795|8|car battery flooded battery|Wet batteries may contain corrosive electrolyte.|Non spillable provisions cannot be assumed for wet batteries.
Non spillable battery|Batteries|S|2800|8|sealed lead acid sla agm gel battery|Qualifying non spillable batteries may receive conditional relief.|Air A67; sea and road SP238 where applicable.
Alkaline batteries|Batteries|S|Varies|Varies|aa aaa c d alkaline dry cell|Common dry cells may be outside full DG requirements if conditions are met.|Air A123 may apply; short circuit protection is important.
NiMH battery|Batteries|S|3496 / Varies|9 / Varies|nickel metal hydride rechargeable battery|Modal classification can differ for nickel metal hydride batteries.|Sea SP963 and air A123 may be relevant, subject to conditions.
Nickel cadmium battery|Batteries|R|2795 / 3028 / Varies|8 / Varies|nicad ni cd battery|Classification depends on whether the battery is wet or dry.|Confirm chemistry, electrolyte and modal entry.
Sodium ion battery|Batteries|R|3551 / 3552|9|sodium battery organic electrolyte|Newer battery chemistry requiring current regulation checks.|Check applicable packing instructions and modal requirements.
Damaged lithium battery|Batteries|R|3480 / 3481 / 3090 / 3091|9|swollen defective recalled leaking battery|Damaged defective or recalled batteries require specialist assessment.|May be forbidden for air transport; do not offer for shipment without review.
Battery waste for recycling|Batteries|R|Varies|Varies|used batteries recycling waste|Waste and end of life batteries require separate assessment.|Condition chemistry packaging and waste rules must be checked.
Laptop computer|Electronics|S|3481|9|notebook macbook laptop|May contain a lithium ion battery.|PI967 or PI966 depending on battery configuration.
Mobile phone|Electronics|S|3481|9|iphone smartphone cellphone|Usually contains a lithium ion battery.|Check battery condition and applicable equipment provisions.
Tablet computer|Electronics|S|3481|9|ipad tablet|May contain a rechargeable lithium battery.|Check installed battery condition and applicable provisions.
Smartwatch|Electronics|S|3481|9|apple watch fitness watch|Small rechargeable battery inside equipment.|Small battery provisions may apply if all conditions are met.
Digital camera|Electronics|S|3481 / 3091|9|camera dslr|Battery chemistry and configuration determine requirements.|Check installed or spare batteries separately.
Drone|Electronics|R|3481 / 3480|9|quadcopter uav drone batteries|Aircraft and spare batteries may require separate classifications.|Check each battery capacity and packing configuration.
Cordless drill|Electronics|S|3481 / 3480|9|power tool makita dewalt milwaukee|Rechargeable tools may contain lithium batteries.|Spare batteries require separate review.
Bluetooth speaker|Electronics|S|3481|9|portable speaker|May contain a rechargeable lithium battery.|Check Wh and battery condition.
Wireless headphones|Electronics|S|3481|9|airpods earbuds headset|Small lithium batteries may be installed.|Check battery chemistry and equipment provisions.
Gaming console|Electronics|S|Varies|9 / Varies|playstation nintendo switch xbox|Some consoles and controllers contain batteries.|Check whether batteries are included and their chemistry.
GPS tracker|Electronics|S|3481 / 3091|9|tracking device gps logger|Often contains a lithium battery.|Check active tracking devices and carrier requirements.
AirTag tracker|Electronics|S|3091|9|bluetooth tracker coin cell|Usually contains a lithium metal coin cell.|Check cell specifications and equipment provisions.
Electric toothbrush|Electronics|S|3481 / Varies|9 / Varies|rechargeable toothbrush|May contain a rechargeable battery.|Check battery chemistry and capacity.
Electric shaver|Electronics|S|3481 / Varies|9 / Varies|razor trimmer|Battery powered personal care equipment.|Check installed battery specifications.
Disposable vape|Electronics|R|3481 / Varies|9 / Varies|vape e cigarette electronic cigarette|Battery and liquid contents may present multiple hazards.|Air transport and carrier restrictions require review.
Perfume|Cosmetics|R|1266|3|fragrance cologne eau de parfum|Alcohol based fragrances are often flammable liquids.|Check flash point composition and limited quantity eligibility.
Alcohol based aftershave|Cosmetics|R|1266 / 1170|3|aftershave cologne|May be a flammable liquid.|Confirm SDS and correct entry.
Nail polish|Cosmetics|R|1263 / 1993|3|nail varnish lacquer|Often contains flammable solvents.|Check formulation flash point and packing group.
Nail polish remover|Cosmetics|R|1090 / 1993|3|acetone remover|May contain acetone or other flammable solvents.|Check composition and flash point.
Hairspray aerosol|Cosmetics|R|1950|2.1 / 2.2|hair spray spray can|Pressurised aerosol often flammable.|Check propellant capacity and modal limitations.
Deodorant aerosol|Cosmetics|R|1950|2.1 / 2.2|body spray antiperspirant|Pressurised cosmetic aerosol.|Check propellant and classification.
Roll on deodorant|Cosmetics|N|Varies|Varies|stick deodorant non aerosol|Many non aerosol deodorants are not DG.|Alcohol rich or other hazardous formulations may still be DG.
Shampoo|Cosmetics|N|Varies|Varies|hair shampoo conditioner|Typical water based shampoo is generally not DG.|Confirm formulation and SDS if uncertain.
Body lotion|Cosmetics|N|Varies|Varies|moisturiser cream skincare|Typical non hazardous creams are generally not DG.|Check alcohol content and other hazardous ingredients.
Sunscreen lotion|Cosmetics|N|Varies|Varies|sunblock spf cream|Many non aerosol sunscreens are not DG.|Aerosol sunscreen must be assessed separately.
Sunscreen aerosol|Cosmetics|R|1950|2.1 / 2.2|spray sunscreen|Pressurised aerosol sunscreen.|Check propellant and modal requirements.
Hand sanitiser|Cosmetics|R|1170 / 1987 / 1993|3|hand sanitizer alcohol gel|Alcohol based sanitiser is often flammable.|Check alcohol concentration and flash point.
Essential oils|Cosmetics|R|Varies|3 / 9 / Varies|aromatherapy fragrance oil|Classification varies significantly by oil.|Check flash point environmental hazards and SDS.
Makeup powder|Cosmetics|N|Varies|Varies|face powder eyeshadow blush|Many conventional cosmetic powders are not DG.|Confirm composition and absence of hazardous ingredients.
Lipstick|Cosmetics|N|Varies|Varies|lip balm cosmetics|Typical solid lipstick is generally not DG.|Check unusual formulations.
Petrol|Automotive|R|1203|3|gasoline fuel unleaded|Highly flammable motor fuel.|Full DG review and carrier acceptance required.
Diesel fuel|Automotive|R|1202|3|diesel gas oil|Combustible or flammable fuel subject to classification.|Check fuel specifications and modal requirements.
Kerosene|Automotive|R|1223|3|paraffin lamp oil|Flammable or combustible petroleum product.|Confirm flash point and entry.
Engine oil|Automotive|N|Varies|Varies|motor oil lubricating oil|Many conventional engine oils are not DG for transport.|Check SDS flash point and environmental classification.
Brake fluid|Automotive|N|Varies|Varies|dot 3 dot 4 brake fluid|Many conventional brake fluids are not DG.|Check formulation and SDS.
Antifreeze|Automotive|N|Varies|Varies|coolant ethylene glycol|Many common automotive coolants are not DG.|Check formulation and SDS.
Car battery|Automotive|R|2794 / 2800|8|vehicle starter battery|Classification depends on wet or non spillable construction.|A67 or SP238 may apply only to qualifying batteries.
Airbag module|Automotive|R|3268|9|air bag inflator safety device|Pyrotechnic safety device requiring classification.|Special provisions may apply only to approved designs.
Seatbelt pretensioner|Automotive|R|3268|9|seat belt inflator|May contain pyrotechnic components.|Confirm manufacturer classification.
Tyre inflator aerosol|Automotive|R|1950|2.1 / 2.2|tire sealant spray|Pressurised aerosol.|Check propellant and container details.
Car polish|Automotive|R|Varies|3 / Varies|vehicle polish detailing solvent|Solvent based polishes may be flammable.|Check flash point and SDS.
Windshield washer fluid|Automotive|R|Varies|3 / Varies|windscreen wash methanol|Alcohol containing washer fluids may be flammable.|Check formulation and flash point.
Paint thinner|Chemicals|R|1263 / 1993|3|thinners solvent reducer|Commonly flammable solvent mixture.|Check SDS and proper shipping name.
Solvent based paint|Chemicals|R|1263|3|enamel paint lacquer coating|May be classified as flammable paint.|Check flash point viscosity and applicable provisions.
Water based paint|Chemicals|S|1263 / Varies|3 / Varies|acrylic paint latex paint|Some water based paints are not DG while others remain regulated.|Verify formulation flash point and SDS.
Paint related material|Chemicals|R|1263|3|paint hardener coating material|Classification depends on exact product.|Check SDS hazards and packing group.
Epoxy resin|Chemicals|R|3082 / 1866 / Varies|9 / 3 / Varies|epoxy adhesive resin|May be environmentally hazardous or flammable.|Check resin and hardener separately.
Epoxy hardener|Chemicals|R|1760 / 2735 / Varies|8 / Varies|amine hardener curing agent|Some hardeners are corrosive.|Check SDS and mixture classification.
Super glue|Chemicals|R|1993 / Varies|3 / Varies|cyanoacrylate adhesive|Classification varies by adhesive formulation.|Check flash point and SDS.
PVA glue|Chemicals|N|Varies|Varies|white craft glue wood glue|Typical water based PVA glue is generally not DG.|Check SDS and formulation.
Contact adhesive|Chemicals|R|1133|3|contact cement solvent glue|Solvent based adhesives are often flammable.|Check flash point and packing group.
Silicone sealant|Chemicals|S|Varies|Varies|silicone caulk sealant|Many products are not DG but some release hazardous substances.|Check SDS and formulation.
Acetone|Chemicals|R|1090|3|acetone solvent|Highly flammable liquid.|Check packaging and modal requirements.
Ethanol|Chemicals|R|1170|3|ethyl alcohol alcohol solution|Flammable liquid depending on concentration.|Check concentration and packing group.
Isopropyl alcohol|Chemicals|R|1219|3|ipa isopropanol rubbing alcohol|Flammable liquid.|Check concentration and flash point.
Methanol|Chemicals|R|1230|3 (6.1)|methyl alcohol|Flammable and toxic liquid.|Review subsidiary hazard and packing requirements.
Hydrogen peroxide|Chemicals|R|2014 / 2984 / Varies|5.1 / 8 / Varies|peroxide solution|Classification depends strongly on concentration.|Check concentration stability and SDS.
Hydrochloric acid|Chemicals|R|1789|8|muriatic acid|Corrosive acid.|Check concentration and packing group.
Sulphuric acid|Chemicals|R|1830 / 2796|8|sulfuric acid battery acid|Corrosive acid with concentration dependent entries.|Check composition and applicable UN entry.
Nitric acid|Chemicals|R|2031 / 2032|8 / 5.1|nitric acid solution|Corrosive and potentially oxidising acid.|Check concentration and fuming properties.
Sodium hydroxide solution|Chemicals|R|1824|8|caustic soda liquid|Corrosive alkaline solution.|Check concentration and packing group.
Sodium hydroxide solid|Chemicals|R|1823|8|caustic soda pellets lye|Corrosive solid.|Check packaging and transport classification.
Bleach|Cleaning|R|1791 / Varies|8 / Varies|sodium hypochlorite bleach|Concentrated bleach may be corrosive.|Check available chlorine concentration and SDS.
Dishwashing liquid|Cleaning|N|Varies|Varies|dish soap detergent|Typical household dishwashing liquid is generally not DG.|Check concentrated industrial products separately.
Laundry detergent|Cleaning|N|Varies|Varies|washing powder laundry liquid|Many household detergents are not DG.|Check pods concentrates and SDS.
Disinfectant concentrate|Cleaning|R|Varies|3 / 8 / 9 / Varies|industrial disinfectant sanitiser|Hazards vary by active ingredient and concentration.|Check SDS and transport classification.
Drain cleaner|Cleaning|R|1824 / 1760 / Varies|8|drain unblocker caustic cleaner|Often contains corrosive chemicals.|Check exact ingredients and SDS.
Oven cleaner|Cleaning|R|Varies|8 / 2 / Varies|oven spray degreaser|May be corrosive or an aerosol.|Check formulation and container.
Glass cleaner|Cleaning|N|Varies|Varies|window cleaner|Many water based glass cleaners are not DG.|Check alcohol content and SDS.
Pool chlorine|Chemicals|R|2880 / 1748 / Varies|5.1 / Varies|pool shock calcium hypochlorite|Oxidising pool chemicals can be hazardous.|Confirm chemical identity and concentration.
Pool acid|Chemicals|R|1789 / Varies|8|swimming pool acid|Often contains corrosive acid.|Check SDS and concentration.
Fertiliser|Garden|R|2067 / 2071 / Varies|5.1 / 9 / Varies|ammonium nitrate fertilizer|Classification depends on chemical composition.|Check fertiliser type and SDS.
Garden soil|Garden|N|Varies|Varies|potting mix compost soil|Ordinary soil is generally not DG.|Biosecurity and import restrictions may apply.
Plant seeds|Garden|N|Varies|Varies|flower seeds vegetable seeds|Seeds are generally not DG.|Biosecurity restrictions may apply.
Pesticide|Garden|R|Varies|3 / 6.1 / 9 / Varies|insecticide pesticide spray|May be toxic flammable or environmentally hazardous.|Check active ingredients concentration and SDS.
Herbicide|Garden|R|Varies|6.1 / 9 / Varies|weedkiller glyphosate|Some formulations are regulated.|Check exact formulation and SDS.
Aerosol insect spray|Garden|R|1950|2.1 / 2.2|bug spray insect aerosol|Pressurised aerosol.|Check propellant and pesticide hazards.
Camping gas canister|Gases|R|2037 / 1011 / Varies|2.1|butane cartridge camping stove gas|Flammable gas container.|Check gas composition and container type.
LPG cylinder|Gases|R|1075|2.1|propane butane gas bottle|Flammable liquefied gas.|Check cylinder certification and carrier acceptance.
Oxygen cylinder|Gases|R|1072|2.2 (5.1)|compressed oxygen medical oxygen|Oxidising compressed gas.|Check cylinder and valve requirements.
Carbon dioxide cylinder|Gases|R|1013|2.2|co2 cylinder gas bottle|Compressed nonflammable gas.|Check pressure receptacle requirements.
Nitrogen cylinder|Gases|R|1066|2.2|compressed nitrogen|Compressed gas.|Check cylinder certification and pressure.
Helium cylinder|Gases|R|1046|2.2|helium balloon gas|Compressed gas.|Check cylinder type and carrier restrictions.
Aerosol spray paint|Aerosols|R|1950|2.1 / 2.2|spray paint can|Pressurised aerosol containing paint.|Check propellant capacity and classification.
WD40 aerosol|Aerosols|R|1950|2.1 / Varies|lubricant spray penetrating oil|Often a flammable aerosol.|Confirm product SDS.
Compressed air duster|Aerosols|R|1950 / Varies|2.1 / 2.2|air duster electronics spray|May contain liquefied flammable gas.|Check propellant and SDS.
Fire extinguisher|Safety|S|1044|2.2|portable extinguisher|Certain fire extinguishers may qualify for special provisions.|Air A19 and sea or road SP225 may apply subject to conditions.
Smoke detector|Safety|S|Varies|7 / 9 / Varies|ionisation smoke alarm|Some detectors contain small radioactive sources or batteries.|Check detector type and applicable exceptions.
Life jacket with gas cylinder|Safety|S|2990 / 3072 / Varies|9 / 2|inflatable lifejacket co2 cartridge|Inflation devices may qualify for specific provisions.|Check current modal provisions and cylinder configuration.
Dry ice|Medical|R|1845|9|solid carbon dioxide frozen co2|Releases carbon dioxide gas during transport.|Air PI954 and applicable quantity marking and ventilation rules.
Biological specimen category B|Medical|S|3373|6.2|diagnostic sample clinical specimen|Category B biological substance.|Air PI650 and applicable sea or road packing requirements.
Infectious substance category A|Medical|R|2814 / 2900|6.2|infectious pathogen sample|High consequence infectious material.|Specialist classification and packaging required.
Exempt human specimen|Medical|S|Varies|Varies|exempt patient specimen blood test|May qualify as an exempt specimen if criteria are satisfied.|Exempt specimen marking and packaging requirements may apply.
Blood samples|Medical|R|3373 / 2814 / Varies|6.2 / Varies|blood tube sample|Classification depends on infectious risk and purpose.|Review patient risk specimen type and packaging.
Medical oxygen concentrator|Medical|S|3481 / Varies|9 / Varies|portable oxygen concentrator poc|May contain lithium batteries.|Check equipment battery and transport configuration.
Prescription tablets|Medical|N|Varies|Varies|medicine pills capsules|Many conventional tablets are not DG.|Controlled medicine and import restrictions may apply.
Liquid medication|Medical|S|Varies|Varies|medicine syrup pharmaceutical liquid|Classification depends on alcohol solvents and ingredients.|Check SDS and composition.
Mercury thermometer|Medical|R|2809 / 3506 / Varies|8 / 6.1 / Varies|mercury glass thermometer|Mercury containing articles require review.|Special provisions may apply to qualifying instruments.
Digital thermometer|Medical|S|3481 / 3091 / Varies|9 / Varies|electronic thermometer|May contain a small battery.|Check battery chemistry and equipment provisions.
First aid kit|Medical|S|3316 / Varies|9 / Varies|medical kit emergency kit|Some kits contain small quantities of dangerous goods.|Air A44 and applicable kit provisions may apply.
Chemical kit|Laboratory|S|3316 / Varies|9 / Varies|testing kit reagent kit|Qualifying chemical kits may have special arrangements.|Check kit contents quantity and modal provisions.
Laboratory reagents|Laboratory|R|Varies|Varies|lab chemicals reagents|Classification depends on each substance.|Provide SDS and inventory with quantities.
Lithium battery prototype|Laboratory|R|3480 / 3481 / Varies|9|untested prototype battery|Prototype or low production batteries need specialist review.|Air A88 may apply only with competent authority approval and conditions.
Radioactive material|Laboratory|R|Varies|7|radioactive isotope source|Class 7 material requires specialist assessment.|Activity radionuclide and package type determine requirements.
Magnetised material|Electronics|S|2807 / Varies|9 / Varies|strong magnet neodymium speaker magnet|Air transport can regulate strong magnetic fields.|Air PI953 and magnetic field testing may be relevant.
Speakers without batteries|Electronics|S|2807 / Varies|9 / Varies|loudspeaker subwoofer|Strong magnets may trigger air restrictions.|Magnetic field assessment may be required for air.
Refrigerator|Appliances|R|2857 / 3358 / Varies|2 / 9 / Varies|fridge freezer refrigeration appliance|May contain refrigerant gas or flammable insulation components.|Check refrigerant type and applicable appliance provisions.
Air conditioner|Appliances|R|2857 / 3358 / Varies|2 / 9 / Varies|portable air conditioner|May contain refrigerant under pressure.|Check refrigerant and equipment specifications.
Heat pump|Appliances|R|2857 / 3358 / Varies|2 / 9 / Varies|heatpump unit|Refrigerant systems may be regulated.|Confirm refrigerant type and charge.
Empty cleaned drum|Packaging|N|Varies|Varies|empty clean container jerrican|Properly cleaned and decontaminated packaging may not be DG.|Residues and vapours must be addressed.
Empty uncleaned drum|Packaging|R|Varies|Varies|empty dirty chemical drum|Residues can remain regulated dangerous goods.|Assess previous contents and applicable empty packaging rules.
Used fuel tank|Automotive|R|Varies|3 / Varies|motorcycle tank petrol tank|Residual fuel and vapours can create a hazard.|Check cleaning purging and carrier requirements.
Books|General|N|None|None|paper textbooks novels|Ordinary books are generally not DG.|Other shipping and customs requirements may apply.
Clothing|General|N|None|None|shoes jackets apparel|Ordinary clothing is generally not DG.|Check for concealed batteries or hazardous accessories.
Furniture|General|N|Varies|Varies|table chair desk couch|Ordinary furniture is generally not DG.|Powered furniture or chemical treatments may change assessment.
Ceramic mugs|General|N|None|None|cups crockery pottery|Ordinary ceramic tableware is generally not DG.|Fragile packaging requirements still apply.
Glass bottles empty|General|N|None|None|empty clean glass bottles|Clean empty glass bottles are generally not DG.|Ensure no hazardous residues.
Water bottles filled|General|N|None|None|drinking water bottled water|Ordinary drinking water is not DG.|Leakproof packaging is still important.
Food snacks|General|N|Varies|Varies|biscuits chips packaged food|Most ordinary dry packaged food is not DG.|Refrigerants and import controls may change requirements.
Coffee beans|General|N|None|None|coffee roasted beans|Ordinary roasted coffee beans are not DG.|Food and biosecurity rules may apply.
Tea bags|General|N|None|None|tea leaves herbal tea|Ordinary dry tea is not DG.|Import requirements may apply.
Golf clubs|Sports|N|None|None|golf equipment|Ordinary golf clubs are not DG.|Battery powered golf equipment needs separate assessment.
Surfboard|Sports|N|None|None|surf board|Ordinary surfboards are not DG.|Resin repair chemicals and batteries are separate items.
Snowboard|Sports|N|None|None|ski snowboard|Ordinary snowboards are not DG.|Avalanche airbags and cartridges need review.
Avalanche airbag|Sports|S|2990 / 3072 / Varies|9 / 2|ski airbag backpack|Inflation cartridges may be regulated.|Check gas cylinder and applicable modal provisions.
Camping matches|Sports|R|1944 / Varies|4.1 / Varies|safety matches|Matches may be regulated and air restrictions can apply.|Check match type and modal restrictions.
Lighter|General|R|1057|2.1|cigarette lighter butane lighter|Contains flammable gas or liquid.|Cargo air restrictions and carrier acceptance require review.
Fireworks|General|R|Varies|1|sparklers pyrotechnics|Explosive articles subject to strict restrictions.|Specialist assessment and carrier acceptance required.
Alcoholic spirits|Food|R|3065 / Varies|3 / Varies|whisky vodka gin rum|Alcoholic beverages may be Class 3 depending on strength.|Check ABV quantity and applicable provisions.
Wine|Food|S|3065 / Varies|3 / Varies|red wine white wine|Typical lower ABV wine may not be regulated as DG.|Confirm ABV and applicable entry or exception.
Beer|Food|N|Varies|Varies|lager ale beer cans|Typical beer is generally not DG.|Check alcohol strength and packaging.
Cooking oil|Food|N|Varies|Varies|olive oil vegetable oil|Ordinary edible cooking oil is generally not DG.|Check product SDS if industrial or modified.
Cooking spray aerosol|Food|R|1950|2.1 / 2.2|oil spray aerosol can|Pressurised cooking spray may be flammable.|Check propellant and SDS.
Charcoal|Garden|R|1361 / Varies|4.2 / Varies|barbecue charcoal activated carbon|Certain carbon products can be self heating.|Check manufacturing process testing and modal entry.
Wood pellets|Garden|S|Varies|Varies|wood fuel pellets|Not ordinarily DG as individual dry goods but bulk transport may have gas hazards.|Check bulk cargo and carrier requirements.
Dry cell torch|Electronics|S|Varies|Varies|flashlight torch batteries|Battery type determines transport requirements.|Check installed cells and short circuit protection.
`;

    const categories = [
      "All", "Batteries", "Electronics", "Vehicles",
      "Chemicals", "Cosmetics", "Automotive", "Cleaning",
      "Aerosols", "Gases", "Medical", "Laboratory",
      "Garden", "Safety", "Appliances", "Packaging",
      "Sports", "Food", "General"
    ];

    const data = raw.trim().split("\n").map((line, i) => {
      const p = line.split("|").map(x => x.trim());

      return {
        id: i,
        name: p[0],
        cat: p[1],
        status: p[2],
        un: p[3],
        hazard: p[4],
        aliases: p[5],
        desc: p[6],
        notes: p[7]
      };
    }).filter(item => item.name);

    let mode = "air";
    let category = "All";
    let search = "";
    let limit = 12;

    const expanded = new Set();

    const $ = id => root.querySelector("#" + id);

    const results = $("dgs-results");
    const count = $("dgs-count");
    const more = $("dgs-more");

    if (!results || !count || !more) {
      console.warn("DG Checker: Required HTML elements are missing.");
      return;
    }

    function escapeHTML(value) {
      return String(value ?? "").replace(/[&<>"']/g, char => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      })[char]);
    }

    function statusFor(item) {
      if (item.status === "R") return "R";
      if (item.status === "N") return "N";
      return "S";
    }

    function statusLabel(status) {
      return {
        R: "DG REVIEW REQUIRED",
        S: "SPECIAL PROVISION MAY APPLY",
        N: "GENERALLY NOT DANGEROUS GOODS"
      }[status];
    }

    function statusClass(status) {
      return {
        R: "red",
        S: "amber",
        N: "green"
      }[status];
    }

    function iconFor(cat) {
      return {
        Batteries: "🔋",
        Electronics: "💻",
        Vehicles: "🚗",
        Chemicals: "⚗️",
        Cosmetics: "🧴",
        Automotive: "🔧",
        Cleaning: "🧼",
        Aerosols: "💨",
        Gases: "🧯",
        Medical: "🧪",
        Laboratory: "🔬",
        Garden: "🌱",
        Safety: "🦺",
        Appliances: "⚙️",
        Packaging: "📦",
        Sports: "🏄",
        Food: "🍶",
        General: "📦"
      }[cat] || "📦";
    }

    function modeText(item) {
      if (item.status === "N") {
        return "This product is often not regulated as dangerous goods in its ordinary form. Verify the exact formulation, contents and condition before shipping.";
      }

      if (mode === "air") {
        return "Air transport can have strict quantity limits, packing instructions, aircraft restrictions and operator variations. The applicable IATA entry and packing instruction must be verified.";
      }

      if (mode === "sea") {
        return "Sea transport must be assessed against the current mandatory IMDG Code, including the Dangerous Goods List, applicable special provisions and packing requirements.";
      }

      return "New Zealand road transport must be assessed against the Land Transport Rule: Dangerous Goods and applicable incorporated standards. Small package and limited quantity relief may be available only when all conditions are met.";
    }

    function provisionText(item) {
      if (item.status === "N") {
        return "No exemption is assumed. Confirm that the actual goods do not meet any dangerous goods classification criteria.";
      }

      return item.notes +
        " These are screening references only, not a confirmed list of applicable provisions for this shipment.";
    }

    function questions(item) {
      const q = [
        "What is the exact product name and manufacturer?",
        "Do you have a current SDS or technical specification?",
        "What quantity and packaging will be shipped?",
        "Is the item new, used, damaged or leaking?"
      ];

      if (["Batteries", "Electronics", "Vehicles"].includes(item.cat)) {
        q.push("What is the battery chemistry and Wh rating?");
        q.push("Is the battery standalone, packed with or installed in equipment?");
        q.push("Is a UN38.3 test summary available where required?");
      }

      if (["Chemicals", "Cosmetics", "Cleaning", "Automotive", "Food"].includes(item.cat)) {
        q.push("What is the flash point, concentration or composition where relevant?");
      }

      if (["Gases", "Aerosols"].includes(item.cat)) {
        q.push("What is the gas or propellant and container capacity?");
      }

      if (["Medical", "Laboratory"].includes(item.cat)) {
        q.push("What are the contents and relevant biological or chemical hazards?");
      }

      return q;
    }

    function score(item, query) {
      const n = query.toLowerCase();
      const name = item.name.toLowerCase();
      const aliases = item.aliases.toLowerCase();
      const terms = n.split(/\s+/).filter(Boolean);

      if (name === n) return 100;

      if (item.un.toLowerCase() === n.replace(/^un\s*/, "")) {
        return 90;
      }

      let points = 0;

      if (name.startsWith(n)) points += 50;
      if (name.includes(n)) points += 35;
      if (aliases.includes(n)) points += 25;

      if (
        ("un" + item.un.replace(/\s/g, "")).toLowerCase()
          .includes(n.replace(/\s/g, ""))
      ) {
        points += 15;
      }

      for (const term of terms) {
        if (name.includes(term)) points += 8;
        if (aliases.includes(term)) points += 5;
        if (item.cat.toLowerCase().includes(term)) points += 2;
      }

      return points;
    }

    function quoteLink(item) {
      const params = new URLSearchParams({
        product: item.name,
        transport: mode,
        source: "dangerous-goods-checker"
      });

      return "/pages/request-a-quote?" + params.toString();
    }

    function renderItem(item) {
      const status = statusFor(item);
      const open = expanded.has(item.id);
      const qs = questions(item);

      const transportName =
        mode === "air" ? "Air Freight / IATA" :
        mode === "sea" ? "Sea Freight / IMDG" :
        "NZ Road / NZS 5433";

      return `
        <article class="dgs-item">
          <div class="dgs-item-main">
            <div class="dgs-item-icon" aria-hidden="true">
              ${iconFor(item.cat)}
            </div>

            <div class="dgs-item-body">
              <h3>${escapeHTML(item.name)}</h3>

              <p class="dgs-item-sub">
                ${escapeHTML(item.cat)}
                ${item.un !== "None"
                  ? " · Possible UN " + escapeHTML(item.un)
                  : ""}
              </p>

              <span class="dgs-status ${statusClass(status)}">
                ${statusLabel(status)}
              </span>
            </div>
          </div>

          <button
            class="dgs-expand"
            type="button"
            data-expand="${item.id}"
            aria-expanded="${open}">
            ${open
              ? "− Hide product guidance"
              : "+ View product guidance and shipping considerations"}
          </button>

          <div class="dgs-details" ${open ? "" : "hidden"}>
            <p>${escapeHTML(item.desc)}</p>

            <div class="dgs-detail-grid">
              <div>
                <strong>Possible UN entry</strong>
                ${escapeHTML(item.un)}
              </div>

              <div>
                <strong>Possible hazard class</strong>
                ${escapeHTML(item.hazard)}
              </div>

              <div>
                <strong>Selected transport</strong>
                ${transportName}
              </div>

              <div>
                <strong>Screening result</strong>
                ${statusLabel(status)}
              </div>
            </div>

            <strong>Transport considerations</strong>
            <p>${escapeHTML(modeText(item))}</p>

            <div class="dgs-notice">
              <strong>Possible provisions and exceptions</strong>
              <p>${escapeHTML(provisionText(item))}</p>
            </div>

            <div class="dgs-review-questions">
              <strong>Information to confirm</strong>
              <ul>
                ${qs.map(q =>
                  "<li>" + escapeHTML(q) + "</li>"
                ).join("")}
              </ul>
            </div>

            <a
              class="dgs-primary"
              href="${escapeHTML(quoteLink(item))}">
              REQUEST A DG REVIEW →
            </a>

            <p style="font-size:11px;color:#777;margin:12px 0 0">
              The quote page may not automatically import these details.
              Include the product name and specifications in your enquiry.
            </p>
          </div>
        </article>
      `;
    }

    const catBox = $("dgs-categories");

    if (!catBox) return;

    catBox.innerHTML = categories.map(cat => `
      <button
        type="button"
        data-category="${escapeHTML(cat)}"
        class="${cat === category ? "active" : ""}">
        ${escapeHTML(cat)}
      </button>
    `).join("");

    function updateCategories() {
      catBox.querySelectorAll("button").forEach(button => {
        button.classList.toggle(
          "active",
          button.dataset.category === category
        );
      });
    }

    function render() {
      let matches = data.filter(item =>
        category === "All" || item.cat === category
      );

      if (search.trim()) {
        matches = matches
          .map(item => ({
            item,
            rank: score(item, search.trim())
          }))
          .filter(result => result.rank > 0)
          .sort((a, b) => b.rank - a.rank)
          .map(result => result.item);
      }

      count.textContent = matches.length + " products found";

      if (!matches.length) {
        results.innerHTML = `
          <div class="dgs-empty">
            <h3>No matching products found</h3>
            <p>
              This does not mean the item is not dangerous goods.
              Our team can review it.
            </p>
            <a
              href="/pages/request-a-quote"
              class="dgs-primary">
              ASK DG SOLUTIONS →
            </a>
          </div>
        `;
      } else {
        results.innerHTML = matches
          .slice(0, limit)
          .map(renderItem)
          .join("");
      }

      more.hidden = matches.length <= limit;

      more.textContent =
        "Load more products (" +
        Math.max(0, matches.length - limit) +
        " remaining)";
    }

    catBox.addEventListener("click", event => {
      const button = event.target.closest("[data-category]");

      if (!button) return;

      category = button.dataset.category;
      limit = 12;
      expanded.clear();

      updateCategories();
      render();
    });

    root.querySelectorAll("[data-mode]").forEach(button => {
      button.addEventListener("click", () => {
        mode = button.dataset.mode;

        root.querySelectorAll("[data-mode]").forEach(other => {
          const active = other === button;

          other.classList.toggle("active", active);
          other.setAttribute("aria-pressed", String(active));
        });

        render();
      });
    });

    const searchInput = $("dgs-search");

    if (searchInput) {
      searchInput.addEventListener("input", event => {
        search = event.target.value;
        category = "All";
        limit = 12;
        expanded.clear();

        updateCategories();
        render();
      });
    }

    const clearButton = $("dgs-clear");

    if (clearButton && searchInput) {
      clearButton.addEventListener("click", () => {
        searchInput.value = "";
        search = "";
        category = "All";
        limit = 12;
        expanded.clear();

        updateCategories();
        render();
        searchInput.focus();
      });
    }

    root.querySelectorAll("[data-query]").forEach(button => {
      button.addEventListener("click", () => {
        search = button.dataset.query;

        if (searchInput) {
          searchInput.value = search;
        }

        category = "All";
        limit = 12;
        expanded.clear();

        updateCategories();
        render();
      });
    });

    results.addEventListener("click", event => {
      const button = event.target.closest("[data-expand]");

      if (!button) return;

      const id = Number(button.dataset.expand);

      if (expanded.has(id)) {
        expanded.delete(id);
      } else {
        expanded.add(id);
      }

      render();
    });

    more.addEventListener("click", () => {
      limit += 12;
      render();
    });

    render();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialiseDGChecker
    );
  } else {
    initialiseDGChecker();
  }
})();
